/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum ApiTokenLifetime {
  DAYS_30="DAYS_30",
DAYS_90="DAYS_90",
DAYS_180="DAYS_180",
ONE_YEAR="ONE_YEAR"
}

/**
* ApiTokenLifetime
*/
export const ApiTokenLifetimeEnumType = types.enumeration("ApiTokenLifetime", [
        "DAYS_30",
  "DAYS_90",
  "DAYS_180",
  "ONE_YEAR",
      ])
